import { IProductInfoFromContentful } from 'app/(main)/(catalog)/category/[slug]/_types'
import {
  mapProductContentfulData,
  productDataToProductTile,
} from 'app/(main)/(catalog)/category/[slug]/_utils'
import { ProductVariant } from '@commerce/types'
import { Entry } from 'contentful'
import { IProductCategory } from 'types/contentful/productCategory'
import { TCrossSellItem } from 'types/crossSell'

export const defaultYouAlsoMayLike = [
  {
    primaryImage: {
      imageUrl: '/images/product/slider/noissue-Tape.png',
      imageTitle: 'noissue Tape',
    },
    productName: 'noissue Tape',
    linkUrl: '/custom-packaging/custom-packing-tape/',
  },
  {
    primaryImage: {
      imageUrl: '/images/product/slider/noissue-Tissue2.png',
      imageTitle: 'noissue Tissue',
    },
    productName: 'noissue Tissue',
    linkUrl: '/custom-packaging/custom-printed-tissue-paper/',
  },
  {
    primaryImage: {
      imageUrl: '/images/product/slider/noissue-Stickers.png',
      imageTitle: 'noissue Stickers',
    },
    productName: 'noissue Stickers',
    linkUrl: '/custom-packaging/custom-printed-stickers/',
  },
  {
    primaryImage: {
      imageUrl: '/images/product/slider/noissue-Stamps.png',
      imageTitle: 'noissue Stamps',
    },
    productName: 'noissue Stamps',
    linkUrl: '/custom-packaging/custom-stamps/',
  },
  {
    primaryImage: {
      imageUrl: '/images/product/slider/noissue-Cards.png',
      imageTitle: 'noissue Cards',
    },
    productName: 'noissue Cards',
    linkUrl: '/custom-packaging/custom-cards/',
  },
  {
    primaryImage: {
      imageUrl: '/images/product/slider/noissue-Mailers.png',
      imageTitle: 'noissue Compostable Mailers',
    },
    productName: 'noissue Compostable Mailers',
    linkUrl: '/custom-packaging/wholesale-custom-compostable-mailers/',
  },
] as TCrossSellItem[]

export const getProductTileData = ({
  productCategoryWithVariants,
  allProductSlugs,
}: {
  productCategoryWithVariants: Entry<IProductCategory> & {
    productVariants?: ProductVariant[]
  }
  allProductSlugs: string[]
}) => {
  const contentfulData = mapProductContentfulData(
    productCategoryWithVariants,
    allProductSlugs
  ) as IProductInfoFromContentful
  return productDataToProductTile({
    ...contentfulData,
    variants: productCategoryWithVariants?.productVariants,
  })
}
